import { createAsyncAction, } from 'typesafe-actions';

import * as types from './types';

export const updateCheckoutComplete = createAsyncAction(
    types.UPDATE_CHECKOUT_COMPLETE_REQUEST,
    types.UPDATE_CHECKOUT_COMPLETE_SUCCEEDED,
    types.UPDATE_CHECKOUT_COMPLETE_FAILED,
)<never, never, never>();
